import React from 'react';
import { Box, DataTable } from '../../../../common/components';
import { applyFilter } from '../../../../common/components/DataTable/redux/dataTableActions';
import { TableHeaderColumn } from 'react-bootstrap-table';
import { ControlLabel, FormControl, Row, Col } from 'react-bootstrap';
import { push } from 'react-router-redux';
import formatDateTime from '../../../../helpers/formatDateTime';
import selectTheme from '../../../../helpers/selectTheme';
import { connect } from 'react-redux';
import Select from 'react-select';

const COMPLAINT_RESPONSE_OPTIONS = [
  { label: 'Received', value: 'received' },
  { label: 'Responded', value: 'responded' },
];

const MtaRequestList = ({ dispatch }) => {
  const handleRowClick = (row) => {
    dispatch(push('/admin/mta-requests/' + row.id));
  };

  const handleFilterUpdate = (option) => {
    dispatch(applyFilter('mta-requests', 'filter[status]', option ? option.value : ''));
  };

  const handleSearchUpdate = (event) => {
    dispatch(applyFilter('mta-requests', 'filter[reference]', event.target.value));
  };

  return (
    <div>
      <Box>
        <Row>
          <Col sm={4}>
            <ControlLabel>Search</ControlLabel>
            <FormControl onChange={handleSearchUpdate} />
          </Col>
          <Col sm={4}>
            <ControlLabel>Status</ControlLabel>
            <Select
              theme={(theme) => selectTheme(theme)}
              options={COMPLAINT_RESPONSE_OPTIONS}
              onChange={(option) => handleFilterUpdate(option)}
              isClearable
            />
          </Col>
        </Row>
      </Box>

      <Box>
        <DataTable
          source="/mta-requests"
          name="mta-requests"
          showTotal
          onRowSelect={handleRowClick}
        >
          <TableHeaderColumn dataField="id" isKey hidden />

          <TableHeaderColumn dataField="reference">Reference</TableHeaderColumn>

          <TableHeaderColumn dataField="name" dataSort>
            Name
          </TableHeaderColumn>

          <TableHeaderColumn dataField="email" dataSort>
            Email
          </TableHeaderColumn>

          <TableHeaderColumn dataField="status" dataSort width={'180px'}>
            Status
          </TableHeaderColumn>

          <TableHeaderColumn
            dataField="created_at"
            dataFormat={formatDateTime}
            width={'180px'}
          >
            Created At
          </TableHeaderColumn>
        </DataTable>
      </Box>
    </div>
  );
};

export default connect()(MtaRequestList);
